(function ($) {
  'use strict';

  $.fn.mobileNavHeight = function () {

    var self = this,
      $navbarCollapse = $('.navbar-collapse'),
      isOpen = false;

    if ($navbarCollapse.hasClass('show')) {
      isOpen = true;
    }

    function getNavHeight() {
      var tempHeight = 0;

      $navbarCollapse.children().each(function () {
        tempHeight += $(this).outerHeight(true);
      });

      return tempHeight;
    }

    setTimeout(function () {
      var newHeight,
        parentUl;

      if (self.hasClass('navbar-toggler')) {
        newHeight = getNavHeight();

        $navbarCollapse.css('max-height', newHeight);

        if (isOpen) {
          $navbarCollapse.css('height', '');
        } else {
          setTimeout(function () {
            $navbarCollapse.css('height', newHeight);
          }, 401);
        }
      } else {
        if (self.hasClass('sub-nav')) {
          newHeight = self.closest('li').children('ul').height();

          if (isOpen) {
            $navbarCollapse.css('height', newHeight);
          }
        } else if (self.hasClass('sub-nav-back')) {
          parentUl = self.parent('ul').parent().closest('ul');

          if (parentUl.hasClass('navbar-nav')) {
            newHeight = getNavHeight();
          } else {
            newHeight = parentUl.height();
          }
          $navbarCollapse.css('max-height', newHeight);

          if (isOpen) {
            $navbarCollapse.css('height', newHeight);
          }
        }
      }
    }, 1);

    return this;
  };

  function buildNavigation() {
    var navLevel = 0,
      $navbar = $('.navbar').not('.navbar.footer'),
      $navbarToggler = $navbar.find('.navbar-toggler'),
      $navBarNav = $navbar.find('.navbar-nav'),
      $navBarNavLi = $navBarNav.find('.nav-item'),
      $navBarCollapse = $navbar.find('.navbar-collapse'),
      $navBarCollapseChildren = $navBarCollapse.children(),
      $subNavA = $navBarNav.children('li > ul a'),
      $subNav,
      $subNavBack,
      hoverTimeout,
      focusOutTimeout;

    $navbarToggler.on('click', function () {
      if (isMobile) {
        $(this).mobileNavHeight();
      }
    });

    $navBarNavLi.on('mouseenter focusin', function () {
      var self = $(this),
          ul = self.children('ul'),
          li = ul.children('li').not('.sub-nav, .sub-nav-back'),
          ulHeight = 8;

      if (!isMobile) {
        li.each(function () {
            ulHeight += $(this).outerHeight();
        });

        ul.height(ulHeight)
            .addClass('active');

        self.addClass('active');
        self.attr('aria-expanded', true);

        setTimeout(function () {
          if (ul.hasClass('active')) {
            ul.css('overflow', 'visible');
          }
        }, 301);
      }
    });

    $navBarNavLi.on('mouseleave focusout', function () {
      var self = $(this),
          ul = $(this).children('ul');

      if (!isMobile) {
        self.removeClass('active');
        self.attr('aria-expanded', false);
        ul.removeClass('active');

        setTimeout(function () {
          if (!ul.hasClass('active')) {
            ul.css('overflow', 'hidden')
              .height('');
          }
        }, 1);
      }
    });

    $navBarNavLi.each(function () {
      var self = $(this),
        ul = self.children('ul');

      if (ul.length !== 0) {
        self.children('a').append('<span class="sub-nav" role="button" title="Open Submenu"><svg x="0px" y="0px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" width="21" height="21" xml:space="preserve"><path fill="#fff" d="M4,2.7L28,16L4,29.3V2.7z"/></svg></span>');
        ul.prepend('<li class="sub-nav-back" role="button"><svg x="0px" y="0px" viewBox="0 0 32 32" width="21" height="21" style="enable-background:new 0 0 32 32;" xml:space="preserve"><path fill="#fff" d="M28,29.3L4,16L28,2.7V29.3z"/></svg>  Back</li>');
      }
    });

    $subNav = $navBarNav.find('.sub-nav');
    $subNavBack = $navBarNav.find('.sub-nav-back');

    $subNav.on('click', function (event) {
      event.stopPropagation();
      event.preventDefault();

      var self = $(this),
        li = self.closest('li');

      navLevel++;
      li.siblings('li').find('ul').css('display', 'none');
      li.children('ul').css('display', 'block');
      $navBarCollapseChildren.css('left', '-' + navLevel + '00%');
      if (isMobile) {
        setTimeout(function () {
          self.mobileNavHeight();
        }, 1);
      }
    });

    $subNavBack.on('click', function (event) {
      event.stopPropagation();
      event.preventDefault();

      navLevel--;

      if (navLevel <= 0) {
        navLevel = 0;
        $navBarCollapseChildren.css('left', '0');
      } else {
        $navBarCollapseChildren.css('left', '-' + navLevel + '00%');
      }

      if (isMobile) {
        $(this).mobileNavHeight();
      }
    });

    $subNavA.on('focusin', function () {
      var ul = $(this).closest('ul'),
        ulHeight = 0;

      ul.parent('li').addClass('open');

      if (!isMobile) {
        ul.children('li').not('.sub-nav, .sub-nav-back').each(function () {
          ulHeight += $(this).height();
        });
        ul.height(ulHeight);
      }
    });

    $subNavA.on('focusout', function () {
      var ul = $(this).closest('ul');

      ul.parent('li').removeClass('open');
      if (!isMobile) {
        ul.height('');
      }
    });
  }

  window.buildNavigation = buildNavigation;
}(jQuery));
